module.exports = __webpack_public_path__ + "static/img/GL.05ca8e6f.png";